// Liberação pontual da trava contra apagamento em massa (mig 021/027).
// A tela chama liberarRemocaoEmMassa(campo) DEPOIS de a pessoa confirmar uma
// exclusão grande (ex.: pasta com mais de 10 questões). A próxima gravação
// desse campo, dentro de 1 minuto, vai pela RPC atualizar_campo_dados_confirmado;
// depois de gravada, a liberação é consumida. Fica só na memória da aba: um F5
// ou a fila de reenvio nunca herdam a liberação.

const liberacoes = new Map(); // campo → expira em (ms)

export function liberarRemocaoEmMassa(campo, validadeMs = 60000) {
  liberacoes.set(campo, Date.now() + validadeMs);
}

export function remocaoLiberada(campo) {
  const expira = liberacoes.get(campo);
  if (!expira) return false;
  if (Date.now() > expira) { liberacoes.delete(campo); return false; }
  return true;
}

export function consumirLiberacao(campo) {
  liberacoes.delete(campo);
}
